import {pushEdapEvent} from '../../utils/edap';

const ACTION_LOCATION = 'property-reviews';

export function onViewPropertyClick(listingid, position) {
    const event1 = {
        eventcategory: ACTION_LOCATION,
        eventrefinements: `position:${position}`,
        listingid,
    };
    const event2 = {
        listingid,
        event_refinements: `position:${position}`,
    };
    return () => {
        pushEdapEvent('property.tile.click', event1);
        pushEdapEvent('content_tile.selected', event2);
    };
}
